<template>
    <div id="app">
        <div class="container">
            <div style="margin-bottom: 0">
                <Navbar></Navbar>
            </div>
            <div v-if="!this.$route.query.NavigationId && !this.$route.query.nw" class="content-menu">
                <CrmMenu></CrmMenu>
            </div>
            <section class="content-container" :style="(this.$route.query.nw || this.$route.query.NavigationId) && 'margin-left: 0'">
                <div class="content-box">
                    <transition name="fade" mode="out-in" appear>
                        <router-view></router-view>
                    </transition>
                </div>
            </section>
            <div id="callContainer" style="display:none;">
            </div>
        </div>
    </div>
</template>
<style>
    nav {
        margin-bottom: 10px;
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: all .3s
    }

    .fade-enter,
    .fade-leave-active {
        transition: all .3s;
        opacity: 0
    }

    .fold-enter-active {
        animation-name: fold-in;
        animation-duration: .1s;
    }

    .fold-leave-active {
        animation-name: fold-out;
        animation-duration: .1s;
    }

    @keyframes fold-in {
        0% {
            transform: translate3d(0, 100%, 0);
        }
        100% {
            transform: translate3d(0, 0, 0);
        }
    }

    @keyframes fold-out {
        0% {
            transform: translate3d(0, 0, 0);
        }
        100% {
            transform: translate3d(0, 100%, 0);
        }
    }
</style>
<script>
    import Vue from 'vue';
    import Navbar from '../containers/Navigation.vue';
    import CrmMenu from './Menu.vue';
    import {messageTitle, getCallStatus, tianrunCCLogin} from '../util/util';
    import {doLogin} from '../util/tianrunCall.js';
    import {
        CRM_MENU,
        CRM_USER_INFO,
        CRM_TOKEN,
        CRM_OPEN_TABS,
        CRM_CURRENT_LEVEL_ONE_MENU,
        CRM_USER_DEPARTMENT,
        CRM_CERTIFICATES_TYPE,
        CRM_INTENTION_STUDENTS,
        CRM_PROVICE_CITY,
        CRM_CLUES_STATUS,
        CRM_INTENTION_DEGREE,
        CRM_CUSTONER_SOURE,
        CRM_CHANNERLS,
        CRM_CLUES_OPTIMAL,
        CRM_PROFESSIONAL_STATUS,
        CRM_TRAFFIC_STATUS,
        CRM_LABE_LIST,
        CRM_URGENCY,
        CRM_INTENTTION_DEGREE,
        CRM_LATEST_AJAX_TIME,
    } from '../util/keys';
    import {CallInClues, GetLocation} from '../api/message';
    import {addCallRecord, updateCallRecords,updateConnect,updateConnected} from '../api/callCenter';
    import {mapState} from 'vuex';
    import {parseUrl} from 'base';
    import modal from 'vueModal';
    import CrmMessage from '../plugins/message';
    import Access from '../util/accessControl';
    import SendCall from '../util/sendCall';
    import {getEnv, getBaseUrl, getHostName} from '../util/config';
    import { setCookie } from 'cookieUtils';
    import { Message } from 'element-ui';
    import vueModal from 'vueModal';

    Vue.use(Access);
    Vue.use(SendCall);
    export default {
        name: 'app',
        components: {
            Navbar,
            CrmMenu,
        },
        data() {
            return {
                callStatus: []
            }
        },
        created() {
            this.mapMenuToWindow();
            this.mapPageIdToWindow();

            // setTimeout(() => {
            //     console.log(this.$router)
            //     this.messageType50001({Data:JSON.stringify({CustomGuid:'2222'})})
            //     console.log('你打给了奥巴马')
            // },3*1000)
        },
    methods: {
        jumpModal(CustomGuid) {
            // // 移入公海池
            import("../components/cluesManage/OutCallModalJump.vue").then(OutCallModalJump => {
                vueModal.openComponent(OutCallModalJump.default, {
                    title: '自动外呼',
                    showCancelButton: false,
                    showConfirmButton: false,
                    self: this,
                    CustomGuid,
                    width: '350px',
                    callback: (type, self) => {
                       
                    }
                })
            })},
          

            loadAliSdk() {
                let evn = getEnv();
                let sdkUrl ="//g.alicdn.com/acca/workbench-sdk/0.2.3/workbenchSdk.js";
                if (evn == "dev-") {
                    sdkUrl = "//g.alicdn.com/acca/workbench-sdk/0.2.3/workbenchSdk.js";
                }
                let sIPmlScript = document.createElement('script');
                let indexScript = document.createElement('script');
                let workbenchSdk = document.createElement('script');
                sIPmlScript.type = "text/javascript";
                indexScript.type = "text/javascript";
                workbenchSdk.type = "text/javascript";
                sIPmlScript.src = `//g.alicdn.com/crm/acc-phone/1.0.10/SIPml-api.js`
                indexScript.src = `//g.alicdn.com/crm/acc-phone/1.0.10/index.js`
                workbenchSdk.src = sdkUrl;
                var head = document.getElementsByTagName('head')[0];
                head.appendChild(sIPmlScript);
                sIPmlScript.onload = function () {
                    head.appendChild(indexScript);
                    head.appendChild(workbenchSdk);
                };
                workbenchSdk.onload = this.aliCallInit;
            },
            initAliCCStatus() {
                switch (this.extStatusId) {
                    case 1:
                        window.workbench.logOut();
                        break;
                    case 2:
                        window.workbench.ready();
                        break;
                    case 3:
                        window.workbench.applyForBreak();
                        break;
                    case 4:
                        break;
                }
            },
            loadTianRunNewSdk() {
                let userInfo = localStorage.getItem(CRM_USER_INFO);
                userInfo && (userInfo = JSON.parse(userInfo));
                let tianRunScript = document.createElement('script');
                tianRunScript.type = "text/javascript";
                tianRunScript.src =`//agent-gateway-1.cticloud.cn/js/agent/v10/cti-link.js`;
                var head = document.getElementsByTagName('head')[0];
                head.appendChild(tianRunScript);

                let self = this;
                tianRunScript.onload = function () {
                    CTILink.setup({webrtc:userInfo.TrBindType==3, debug:true}, function() {
                        //CTILink加载完成

                        //注册事件处理方法
                        /** 状态事件 */
                        CTILink.event("status", self.handleState);  //当前座席状态
                        CTILink.event("previewOutcallRinging", self.handleState);  //外呼座席响铃
                        CTILink.event("previewOutcallBridge", self.handleState);  //外呼接通
                        CTILink.event("consultStart", self.handleState);  //咨询开始
                        CTILink.event("consultLink", self.handleState);  //咨询接听
                        CTILink.event("consultError", self.handleState);  //咨询失败
                        CTILink.event("unconsult", self.handleState);  //咨询挂断/接回/取消
                        CTILink.event("consultThreeway", self.handleState);  //咨询三方
                        CTILink.event("consultThreewayUnlink", self.handleState);  //咨询三方挂断
                        CTILink.event("consultTransfer", self.handleState);  //咨询转移
                        CTILink.event("breakLine", self.handleBreakLine);  //掉线

                        /** 其他事件 */
                        CTILink.event("ringing", self.handleRinging); //弹屏
                        CTILink.event("kickout", self.handleKickout);  //被踢下线
                        //自动登录
                        doLogin(self);
                    });
                };
            },
            handleBreakLine(event) {
                if (event.code == -1) {
                    if (event.attempts >= 20) {
                        this.$store.dispatch("updateTrCludeStatus", {state:'',stateAction:'', customerNumber: ''});
                        this.$message({
                            message: '自动断线重连失败，请手动签入签出',
                            type: 'warning'
                        });
                    }
                }
            },
            handleState(event) {
                console.log('天润状态',event);
				this.$store.dispatch("updateTrCludeStatus", {state:event.state,stateAction:event.stateAction, customerNumber: event.customerNumber || event.calleeNumber});
                //座席状态描述 : 离线，失效，空闲，置忙，整理，呼叫中，响铃，通话
                var stateShow = event.state;
                switch (event.state) {
                    case '离线':
                        break;
                    case '失效':
                        //软电话状态, 退出
                        this.doLogout();
                        break;
                    case '空闲':
                        break;
                    case '置忙':
                        break;
                    case '呼叫中':
                        break;
                    case '响铃':
                        let isTracking=this.$store.state.cluesManage.isTracking;
                        let clueGuid="";
                        if(isTracking){
                            clueGuid=this.$store.state.cluesManage.getTrackingIds.Guid;
                        }
                        switch(event.stateAction) {
                            case 'ringingIb' : //呼入座席响铃
                                this.messageType10004({"data": {"FromNo": event.customerNumber, "ToNo": this.userInfo.TrBindTel}});
                                this.addAliCallRecord({
                                    "UserId": this.userInfo.UserId,
                                    "PhoneType": "1",
                                    "CCType": "3",
                                    "CCRecordId": event.mainUniqueId,
                                    "FromNo": event.customerNumber,
                                    "ToNo": this.userInfo.TrBindTel,
                                    "ClueGuid":clueGuid,
                                    "CallSource":1,
                                    "CallCenterId":this.userInfo.TrDepartId
                                });
                                break;
                            case 'ringingAgentOb' : //外呼座席响铃
                                this.addAliCallRecord({
                                    "UserId": this.userInfo.UserId,
                                    "PhoneType": "2",
                                    "CCType": "3",
                                    "CCRecordId": event.uniqueId,
                                    "FromNo": this.userInfo.TrBindTel,
                                    "ToNo": event.customerNumber,
                                    "ClueGuid":clueGuid,
                                    "CallSource":1,
                                    "CallCenterId":this.userInfo.TrDepartId
                                });
                                if(clueGuid){
                                    updateConnect({"ClueGuid":clueGuid});
                                }
                                break;
                            case 'ringingCustomerOb': //外呼客户响铃
                                break;
                        }
                        break;
                    case '通话':
                        switch(event.stateAction) {
                            case 'busyIb' : //呼入座席接听
                                break;
                            case 'busyOb' : //外呼客户接听 客户和座席通话
                                let isTracking=this.$store.state.cluesManage.isTracking;
                                let clueGuid="";
                                if(isTracking){
                                    clueGuid=this.$store.state.cluesManage.getTrackingIds.Guid;
                                }
                                if(clueGuid){
                                    updateConnected({"ClueGuid":clueGuid});
                                }
                                break;
                            case 'hold' : //保持开始
                                stateShow = '保持';
                                break;
                            case 'unhold' : //保持结束
                                break;
                            case 'consultStart' : //咨询开始
                                break;
                            case 'consultLink' : //咨询成功
                                stateShow = '咨询';
                                break;
                            case 'busyConsult' : //被咨询转接或转移的通话
                            case 'busyTransfer' :
                                break;
                            case 'consultThreeway':
                                stateShow = '咨询三方';
                            default:
                        }
                        break;
                    case '整理':  //整理开始（座席挂断）
                        //this.updateCallRecord();
                        break;
                }
            },
            handleRinging(event) {

            },
            handleKickout(event) {
                if (event.code == 0) {
                    //被踢下线
                    this.$store.dispatch('updateKickOut', 'HasKickOuted')
                    this.$store.dispatch("updateTrCludeStatus", {state: "空闲",stateAction: 'idle', customerNumber: ''});
                    // this.$message({
                    //     type: 'warning',
                    //     message: '您的天润登录被踢下线了, 请手动签出签入!'
                    // })
                }
            },
            doLogout() {
                var params = {};
                params.logoutMode = 1;
                params.removeBinding = 0;
                CTILink.Agent.logout(params, function(result) {
                    if (result.code == 0) {
                        //退出成功
                    }
                });
            },
            loadMessage() {
                let prefix = getEnv();
                let userInfo = localStorage.getItem(CRM_USER_INFO);
                userInfo && (userInfo = JSON.parse(userInfo));
                let script = document.createElement('script');
                script.type = "text/javascript";
                script.src = `/static_v1/js/socket.io.min.js`
                window.crmSocket = null;
                script.onload = () => {
                    let HostName = getHostName(),
                        SocketBaseUrl = HostName.indexOf('pangu.songshuai.com') > -1 ? 'msg-pangu.songshuai.com' : "pangu-ws.myyixue.com",
                        path = '/crm'
                    window.crmSocket = io(SocketBaseUrl, {
                        path: path,
                        reconnection: true
                    });
                    window.crmSocket.on('connect', () => {
                        if (window.socketReconnect === 1) {
                            //location.reload();
                        }
                        crmSocket.emit('sendUserInfo', {
                            UserId: userInfo.UserId,
                            PartialPhone: userInfo.PartialPhone,
                        });
                        crmSocket.on('message', (message) =>{
                            this.handleMessage(message);
                            if(message.MessageType != 30001&&message.MessageType!=40001){
                                this.MessageBrowser(message);
                            }

                        });
                        window.socketReconnect = 1;
                    });
                    window.crmSocket.on('disconnect', function () {
                        console.log("与服务其断开!");
                        window.socketReconnect = 0;
                    });
                }
                document.getElementsByTagName('head')[0].appendChild(script);
            },
            handleMessage(msg) {
                console.log('handleMessage', msg)
                console.log('--------------------------------------------------')
                if (!msg.Data && !msg.data) {
                    return;
                }
                if (this[`messageType${msg.MessageType}`]) {
                    this[`messageType${msg.MessageType}`](msg);
                    return;
                }
                CrmMessage.create({
                    type: 'info',
                    message: msg.Data || msg.data
                });
        },
            //自动外呼弹屏
        messageType50001(msg) {

                console.log(msg,'收到了弹屏messageType50001')
                console.log(JSON.parse(msg.Data),'CustomGuid')

                if (this.$route.path.includes('TmkAutoOutboundCall')) {
                    window.dispatchEvent(new CustomEvent('outCallMsg', {detail: JSON.parse(msg.Data).CustomGuid  }))
                } else {

                    this.jumpModal(JSON.parse(msg.Data).CustomGuid )
                }
              
            },
            // 刷新浏览器的消息
            messageType30001(msg) {
                Message({
                    type: 'warning',
                    message: '系统已升级，请保存当前工作刷新浏览器！',
                    showClose: true,
                    duration: 0
                })
            },
            // 振铃
            messageType10000(msg) {
                if (msg.data) {
                    this.$store.dispatch("setCallInfo", msg.data.RecordId)
                }
                //alert(this.$store.state.callInfo.RecordId);
            },
            // 挂断电话获取通话记录信息
            messageType10003(msg) {
                let vself = this;
                setTimeout(function () {
                    vself.$store.dispatch('getCallInfo', {"extNo": msg.ExtId, "userId": vself.userInfo.UserId});
                }, 1000);
                setTimeout(function () {
                    vself.$store.dispatch('getExtStatus', {"ExtNo": msg.ExtId});
                }, 1000);
            },
            messageType40002(msg){
                this.messageType10004(msg);
            },
            messageType40001(msg){
                if(this.$route.path !== '/clue/getnewclue') {
                    this.$store.dispatch("updateTrCludeStatus", {state: "空闲",stateAction: 'idle', customerNumber: ''});
                    return false
                }
                let isTracking=this.$store.state.cluesManage.isTracking;
                let clueGuid="";
                if(isTracking){
                    clueGuid=this.$store.state.cluesManage.getTrackingIds.Guid;
                }
                if(clueGuid){
                    updateConnect({"ClueGuid":clueGuid});
                }

                let BridgeSec =  Number(msg.data.BridgeSec)
                if (BridgeSec <= 0) {
                    this.$store.dispatch("updateTrCludeStatus", {state: '空闲',stateAction:'HanTian0', customerNumber: msg.data.DestinationNumber});
                } else {
                    if(clueGuid){
                        updateConnected({"ClueGuid":clueGuid});
                    }
                    this.$store.dispatch("updateTrCludeStatus", {state: '空闲',stateAction:'HanTian1', customerNumber: msg.data.DestinationNumber});

                }
            },
            // 来电信息
            messageType10004(msg) {
                CallInClues({phoneNo: msg.data.FromNo}).then(ret => {
                    if (ret.status === 0) {
                        this.CallInData = ret.result;
                        GetLocation({phone: msg.data.FromNo}).then(res => {
                            if(res.status === 0) {
                                let Location = (res.result.Province || '') + (res.result.City ? ('-'+res.result.City) : '')
                                let CallFromNo = {
                                    FromNo: msg.data.FromNo,
                                    ToNo: msg.data.ToNo,
                                    Location: Location || '暂无归属地'
                                }
                                import("../components/message/CallIn.vue").then(CallIn => {
                                    modal.openComponent(CallIn.default, {
                                        title: '来电信息',
                                        showCancelButton: false,
                                        width: '950px',
                                        CallInData: ret.result,
                                        CallFromNo,
                                        self: this
                                    });
                                });
                            }
                        })
                    }
                })
            },
            messageDesktop(msg) {
                if (Notification.permission == "granted") {
                    let text = msg.Data;
                    if (!text)
                        return;
                    var notification = new Notification("消息提示:", {
                        // body: text.replace(/<[^>]+>/g, "")
                        body: text.replace(/<|>/g, "")
                    });
                    notification.onclick = function () {
                        window.focus();
                        notification.close();
                    };
                }
            },
            MessageBrowser(message) {
                // messageTitle.show();
                // setTimeout(() => {
                //     messageTitle.clear();
                // },5000)
                // window.onfocus = function() {
                //     messageTitle.clear();
                // };
                // document.onfocusin = function() {
                //     messageTitle.clear();
                // };
                if (window.Notification) {
                    if (Notification.permission == "granted") {
                        this.messageDesktop(message);
                    } else if (Notification.permission != "denied") {
                        Notification.requestPermission(function (permission) {
                            this.messageDesktop(message);
                        });
                    }
                } else {
                    console.log('浏览器不支持Notification');
                }
            },
            messageType20014(msg) {
                CrmMessage.create({
                    type: 'balloon', // car ,plane
                    message: msg.Data
                });
            },
            messageType20015(msg) {
                CrmMessage.create({
                    type: 'car', // car ,plane
                    message: msg.Data
                });
            },
            messageType20016(msg) {
                CrmMessage.create({
                    type: 'plane', // car ,plane
                    message: msg.Data
                });
            },
            messageType200023(msg) {
                CrmMessage.create({
                    type: 'FirstPrice',
                    message: msg.Data,
                    time: 7000
                });
            },
            messageType200024(msg) {
                CrmMessage.create({
                    type: 'SecondPrice',
                    message: msg.Data,
                    time: 4500
                });
            },
            messageType200025(msg) {
                CrmMessage.create({
                    type: 'ThirdPrice',
                    message: msg.Data,
                    time: 4500
                });
            },
            mapMenuToWindow() {
                let menu = localStorage.getItem(CRM_MENU);
                window.Menu = JSON.parse(menu);
            },
            mapPageIdToWindow() {
                var mapMethod = menu => {
                    for (var i in menu) {
                        if (menu[i].ChildNavigations) {
                            mapMethod(menu[i].ChildNavigations);
                        }
                    }
                }
                mapMethod(window.Menu);
            },
            addAliCallRecord(parms) {
                addCallRecord(parms).then(ret => {
                    if (ret.status === 0) {
                        this.$store.dispatch("setCallInfo", ret.result);
                    }
                });
            },
            updateCallRecord() {
                var recordId = this.$store.state.callInfo.RecordId
                var parms = [recordId];
                updateCallRecords(parms).then(ret => {
                    if (ret.status === 0) {

                    }
                });
            },
            //阿里呼叫中心
            aliCallInit() {
                var self = this;
                let prefix = getEnv();
                var aliCC = this.userInfo.SysAliyunMq ? this.userInfo.SysAliyunMq[0] : null;
                if (!aliCC || !aliCC.MqId) {
                    return;
                }
                window.workbench = new WorkbenchSdk({
                    dom: 'callContainer',
                    afterCallRule: 5,
                    instanceId: aliCC.MqId,
                    ajaxPath: '/AliCC/CCapi',
                    ajaxOtherParams: {"userId": this.userInfo.UserId},
                    ajaxOrigin: `://crm.songshuai.com`,
                    ajaxMethod: 'post',
                    header: true,
                    onInit: function () {
                        setTimeout(() => {
                            //getCallStatus(self);
                            window.workbench.register();
                        }, 1000);
                    },
                    onErrorNotify: function (error) {
                        console.warn(error)
                    },
                    onCallComing: function (connid, caller, calee, contactId) {
                        self.messageType10004({"data": {"FromNo": caller, "ToNo": calee}});
                        self.addAliCallRecord({
                            "UserId": self.userInfo.UserId,
                            "PhoneType": "1",
                            "CCType": "2",
                            "CCRecordId": contactId,
                            "FromNo": caller,
                            "ToNo": calee,
                            "CallSource":1
                        });
                        getCallStatus(self);
                    },
                    onCallDialing: function (connid, caller, calee, contactId) {
                        let isTracking=self.$store.state.cluesManage.isTracking;
                        let clueGuid="";
                        if(isTracking){
                            clueGuid=self.$store.state.cluesManage.getTrackingIds.Guid;
                        }
                        self.addAliCallRecord({
                            "UserId": self.userInfo.UserId,
                            "PhoneType": "2",
                            "CCType": "2",
                            "CCRecordId": contactId,
                            "FromNo": caller,
                            "ToNo": calee,
                            "ClueGuid":clueGuid,
                            "CallSource":1
                        });
                        getCallStatus(self);
                    },
                    onLogIn: function () {
                        //getCallStatus(self);
                    },
                    onBreak: function () {
                        //getCallStatus(self);
                    },
                    onReady: function () {
                        //getCallStatus(self);
                    },
                    onHangUp: function () {
                        getCallStatus(self);
                        setTimeout(() => {
                            //self.updateCallRecord();
                            self.$store.dispatch('getCallInfo', {
                                "extNo": self.userInfo.PartialPhone,
                                "userId": self.userInfo.UserId
                            });
                        }, 1000);
                    },
                    onStatusChange: function (code, lastCode, context) {
                        console.log("aliStatus:"+code+" lastCode:"+lastCode);
                        self.$store.dispatch("setCallStatus",code);
                        //getCallStatus(self);
                    }
                });
                //初始化呼叫中心状态

            },
            appendFeedback() {
                let script = document.createElement('script');
                script.type = "text/javascript";
                let baseUrl = getBaseUrl()
                let pre = baseUrl.match(/^.*-/);
                if (pre === null) { // 生产环境
                    script.src =  '//feedback.songshuai.com/source/feedback.pro.js';
                } else {
                    // 测试及预发布环境
                    // pre[0] = pre[0] == 'test-' ? 'test-' : pre[0];
                    // script.src = `//${pre[0]}feedback.myyixue.com/source/feedback.js`
                    script.src = `//test-feedback.myyixue.com/source/feedback.js`
                }
                script.onload = () => {
                    let userAccount = JSON.parse(localStorage.getItem(CRM_USER_INFO)).Email
                    let name = JSON.parse(localStorage.getItem(CRM_USER_INFO)).TrueName
                    $_feedback.init('crm',userAccount,name)
                }
                document.querySelector('head').appendChild(script);
            },
        },
        computed: {
            ...mapState({
                count: state => {
                    return state.list.number
                },
                extStatusId: state => {
                    return state.navigation.extStatusId;
                },
                aliCallStatus: state => {
                    return state.navigation.aliCallStatus;
                }
            }),
        },

        mounted() {
            if(this.unlocking('CRM_FEEDBACK')) {
                this.appendFeedback()
            }
            this.loadMessage();
            let currUserInfo = localStorage.getItem(CRM_USER_INFO);
            currUserInfo && (currUserInfo = JSON.parse(currUserInfo));
            this.userInfo = currUserInfo;
            if (this.userInfo.CallCenterType == 2) {
                let nw=this.$route.query.nw;
                if(nw&&nw=="1"){}
                else{
                    this.loadAliSdk();
                }
            } else if (this.userInfo.CallCenterType == 3) {
                this.loadTianRunNewSdk();
            } else if (this.userInfo.CallCenterType == 4) {
                this.$store.dispatch("updateTrCludeStatus", {state: "空闲",stateAction: 'idle', customerNumber: ''});

            }

            // setInterval(() => {
            //     let timer = null;
            //     let date = new Date();
            //     let hours = date.getHours();
            //     if (hours < 1 || hours > 7) { // 1-8点不更新
            //         timer = setInterval(()=>{
            //             this.$store.dispatch('GetUnreadMessageCount') // 每隔10分钟更新TOKEN
            //         },1 * 60 * 1000)
            //     } else {
            //         clearInterval(timer);
            //     }
            // },5 * 60 * 1000)

            let timer = null;
            setInterval(() => {
                let date = new Date();
                let hours = date.getHours();
                if (hours < 1 || hours > 7) { // 1-8点不更新
                    if(timer == null){
                        timer = setInterval(()=>{
                            this.$store.dispatch('GetUnreadMessageCount') // 每隔10分钟更新TOKEN
                        }, 10 * 60 * 1000)
                    }
                } else {
                    clearInterval(timer);
                    timer = null;

                    let prefix = getEnv();
                    setCookie(CRM_TOKEN, undefined, { expires: new Date(0) });
                    setCookie(`${prefix}GDSID`, undefined, { expires: new Date(0) });
                    const loginPageStatus = localStorage.getItem('loginPageStatus');
                    sessionStorage.removeItem(CRM_OPEN_TABS);
                    sessionStorage.removeItem(CRM_USER_DEPARTMENT);
                    sessionStorage.removeItem(CRM_PROVICE_CITY);
                    sessionStorage.removeItem(CRM_CLUES_STATUS);
                    sessionStorage.removeItem(CRM_INTENTION_DEGREE);
                    sessionStorage.removeItem(CRM_CUSTONER_SOURE);
                    sessionStorage.removeItem(CRM_CHANNERLS);
                    sessionStorage.removeItem(CRM_CLUES_OPTIMAL);
                    sessionStorage.removeItem(CRM_PROFESSIONAL_STATUS);
                    sessionStorage.removeItem(CRM_TRAFFIC_STATUS);
                    sessionStorage.removeItem(CRM_LABE_LIST);
                    sessionStorage.removeItem(CRM_URGENCY);
                    sessionStorage.removeItem(CRM_INTENTTION_DEGREE);
                    sessionStorage.removeItem(CRM_CERTIFICATES_TYPE);
                    sessionStorage.removeItem(CRM_INTENTION_STUDENTS);
                    localStorage.clear();
                    this.$store.state.navigation.currentLevelOneId = 489;
                    window.crmSocket && window.crmSocket.disconnect();
                    // 如果是传统登录页，直接跳转到/login页面，否则直接关闭窗口
                    if (loginPageStatus === '1') {
                        window.close();
                    } else {
                        this.$router.push('/login');
                    }
                }
            }, 15 * 60 * 1000)



            let msg = {
                MessageType: '20016',
                Data: '恭喜 XX 团队的 <Honey111> 成功收款 <20000元>'
            }
            // this.messageType20014(msg)
            // this.messageType20015(msg)
            // this.messageType20016(msg)
            // this.messageType200023(msg)
            // this.messageType200024(msg)
            // this.messageType200025(msg)
        }
    }
</script>
